import React, { useState } from 'react'
import useFetch from '../../../hooks/useAxios'
import ReserveCounts from './userstatics/ReserveCounts'
import StaticHeader from './userstatics/StaticHeader'
import TotaolReserve from './userstatics/TotaolReserve'
import YourIncome from './userstatics/YourIncome'

const UserStatics = () => {
  const [StatisticInfo, setStatisticInfo] = useState()
  const fetchStatistic = useFetch({
    method: "get",
    url: "api/host/statistics",
    noHeader: false,
    trigger: true,
    argFunc: res => {
      setStatisticInfo(res.data.statistics)
    }
  });
  
  return (
   <>
   {StatisticInfo &&
      <div>
      <StaticHeader StatisticInfo={StatisticInfo}/>
        <div className='UserStatics-grid-2'>
    
           <TotaolReserve StatisticInfo={StatisticInfo}/>
           <ReserveCounts StatisticInfo={StatisticInfo}/>
        </div>
        <YourIncome StatisticInfo={StatisticInfo}/>
    </div>
   }
   </>
  )
}

export default UserStatics